<template>
  <div class="h-100-pct w-100-pct">
    <div class="h-100-pct vert just-space-between m-x-1v">
      <div class="horiz h-100-pct just-center gap-1v al-it-c">
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(7)> 7 </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(8)> 8 </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(9)> 9 </div>
      </div>
      <div class="horiz h-100-pct just-center gap-1v">
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(4)> 4 </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(5)> 5 </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(6)> 6 </div>
      </div>
      <div class="horiz h-100-pct just-center gap-1v">
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(1)> 1 </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(2)> 2 </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(3)> 3 </div>
      </div>
      <div class="horiz h-100-pct just-center gap-1v">
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent="add_backspace">
          <img class="p-1v h-1-5-rem my-auto" svg-inline src="@/assets/delete.svg"/>
        </div>
        <div class="horiz just-center al-it-c button bg-wt r1 shadow1" @mousedown.prevent=add_number(0)> 0 </div>
        <div class="horiz just-center button r1 shadow1 box" @mousedown.prevent="add_enter">
          <img class="p-1v h-1-5-rem my-auto" svg-inline src="@/assets/arrow.svg"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  setup(props={}, context) {
    function add_number(num) { context.emit('number_click', num) }
    function add_enter() { context.emit('enter_click') }
    function add_backspace() { context.emit('backspace_click') }
    return {
      add_number,
      add_enter,
      add_backspace,
    }
  },
})

</script>

<style scoped>
  .button {
    /* width: min(23vw, 9vh); */
    margin-top: auto;
    margin-bottom: auto;
    width: 100%;
    height: 5.7vh;
    font-size: min(5vw, 3vh);
    line-height: min(7vw, 5vh);
    background-color: var(--primary-light)
  }
</style>
